/**
 * @param {CanvasRenderingContext2D} context - The canvas rendering context.
 * @param {Object} source - The sources to draw on the canvas.
 * @param {HTMLCanvasElement} canvas
 */
function drawOne(context,source,canvas) {
    context.drawImage(source.dom, 0, 0, canvas.width, canvas.height)
}

function drawTwo(context,sources,canvas) {

    for (let index in sources) {
        const source = sources[index];

        const padding = 12;
        const width = canvas.width/2 - (padding*1.5)
        const height = canvas.height/2 - (padding*1.5)

        let x = padding
        if (index > 0 ) {
            x = padding + width + padding
        }
        let y =  (canvas.height/4)

        context.drawImage(source.dom, x, y, width, height)
    }

}

function drawMultiple(context,sources,canvas) {

    let sourcesCount = sources.length

    if (sourcesCount > 16) {
        sourcesCount = 16
    }


    let gridSize = Math.ceil(Math.sqrt(sourcesCount));
    let rowsWithVideo = Math.ceil(sourcesCount/gridSize);
    let colsWithVideoRemain = sourcesCount%gridSize



    for (let index = 0; index < sourcesCount; index++) {



        const source = sources[index];

        const row = Math.floor(index / gridSize);
        const column = index % gridSize;

        const padding = 12;
        const width = canvas.width / gridSize - padding * 1.5;
        const height = canvas.height / gridSize - padding * 1.5;

        const totalSourcesHeight = (rowsWithVideo*height) + (padding*(rowsWithVideo - 1))
        const yCenterRemark = (canvas.height - totalSourcesHeight)/2

        let y =  row * (height + padding)
        y += yCenterRemark

        let x = padding + column * (width + padding);

        if ( rowsWithVideo === (row + 1) && colsWithVideoRemain > 0  ) {

            const totalSourcesWidth = (colsWithVideoRemain*height) + (padding*(colsWithVideoRemain - 1))
            const xCenterRemark = (canvas.width - totalSourcesWidth)/2
            x += xCenterRemark - padding - (padding * 1.5 * colsWithVideoRemain) - padding
        }


        context.drawImage(source.dom, x, y, width, height);
    }
}

function drawCanvas(context,sources,canvas) {

    const sourcesCount = sources.length
    if (!sourcesCount) {
        return
    }

    switch (sourcesCount) {
        case 1 : drawOne(context,sources[0],canvas); return
        case 2 : drawTwo(context,sources,canvas); return
        default : drawMultiple(context,sources,canvas); return
    }

}

export default {
    drawCanvas : drawCanvas
}